module.exports = __webpack_public_path__ + "static/img/login_logo.6f24add1.png";